import { EventsManager, WinEvents } from "../../../abstracts/events/EventsManager";
import { AbstractModuleController } from "../../../abstracts/modules/AbstractModuleController";
import { ApocalypseWinView } from "./ApocalypseWinView";

export class ApocalypseWinController extends AbstractModuleController {
    public get name(): string {
        return `ApocalypseWinController`;
    }

    public get view(): ApocalypseWinView {
        if (this._view === undefined || this._view === null) {
            this._view = new ApocalypseWinView();
        }
        return this._view as ApocalypseWinView;
    }

    protected handleEvents() {
        super.handleEvents();

        EventsManager.trigger(WinEvents.GET_WINNINGS_VIEW, this.view);
    }
}
